import React, { ReactNode, } from "react";
import { DiscadorProvider } from "../components/Discador";
import { DiscadorProvider as DiscExpert } from "../components/DiscadorExpert";

interface OperadoraProviderProps {
  children: ReactNode;
  operadora: string
  socketUrl: string;
  user: string;
  password: string;
  token3C: string;
}


// { children }

export const OperadoraProvider = ({ children, operadora, password, socketUrl, user, token3C }: OperadoraProviderProps) => {

  return (
    <>
      {
        operadora === '3C' ? (
          <DiscadorProvider socketUrl={token3C || ''}
            user={''}
            password={''} >
            {children}
          </DiscadorProvider>
        ) : operadora === 'Expert' ? (
          <DiscExpert socketUrl={socketUrl || ''}
            user={user || ''}
            password={password || ''} >
            {children}
          </DiscExpert>
        ) : <></>
      }
    </>



  );
};




